import { DELETE_ACTION_TENDENCY } from "./types";

const deleteActionTendency = (code) => async (dispatch) => {
    dispatch({ type: DELETE_ACTION_TENDENCY, code });
};

export default deleteActionTendency;
